import React from "react";
import { useNavigate } from "react-router-dom";
import "./DealTable.css";

export default function DropTable({
  leads = [],
  page = 1,
  limit = 100,
  selectedLeads = [],
  toggleLead,
  handleSelectAll,
  showBulkMenu,
  setShowBulkMenu,
  restoreSelected,
  setShowAssignModal,
  handleDeleteSelected,
}) {
  const navigate = useNavigate();

  const stageColor = (stage) => {
    switch (stage) {
      case "New Lead":
        return "#6B7280";

      case "Contacted":
        return "#2563EB";

      case "Inbound":
        return "#0891B2";

      case "Prospect":
        return "#CA8A04";

      case "DNP":
        return "#DC2626";

      case "Qualified":
        return "#CA8A04";

      case "Meeting Done":
        return "#059669";

      case "Site Visit":
        return "#0891B2";

      case "Negotiation":
        return "#9333EA";

      case "Closed Won":
        return "#16A34A";

      case "Closed Lost":
        return "#DC2626";

      default:
        return "#6B7280";
    }
  };

  const menuItem = {
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: 13,
    borderBottom: "1px solid #eee",
    whiteSpace: "nowrap",
  };

  return (
    <div
      className="deal-table-wrapper"
      style={{
        overflowX: "auto",
        overflowY: "visible",
        position: "relative",
        paddingBottom: showBulkMenu ? 210 : 0,
      }}
    >
      <table className="deal-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Lead Date</th>
            <th>Client Name</th>
            <th>Phone</th>
            <th>Source</th>
            <th>Campaign</th>
            <th>Stage</th>
            <th>Drop Reason</th>
            <th>Dropped By</th>
<th>Dropped On</th>
<th>Response Time</th>
<th>Follow-ups</th>
<th>Assigned To</th>

<th style={{ width: 70 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <input
                  type="checkbox"
                  checked={
                    leads.length > 0 &&
                    selectedLeads.length === leads.length
                  }
                  onChange={handleSelectAll}
                />

                {selectedLeads.length > 0 && (
                  <div
                    style={{
                      position: "relative",
                      overflow: "visible",
                    }}
                  >
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();
                        setShowBulkMenu(!showBulkMenu);
                      }}
                      style={{
                        width: 16,
                        height: 16,
                        border: "none",
                        borderRadius: 4,
                        background: "#16A34A",
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 700,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                        lineHeight: 1,
                      }}
                      onMouseEnter={(event) => {
                        event.currentTarget.style.background =
                          "#15803D";
                      }}
                      onMouseLeave={(event) => {
                        event.currentTarget.style.background =
                          "#16A34A";
                      }}
                    >
                      ▼
                    </button>

                    {showBulkMenu && (
                      <div
                        style={{
                          position: "absolute",
                          top: "calc(100% + 8px)",
                          right: 0,
                          width: 210,
                          background: "#fff",
                          border: "1px solid #E5E7EB",
                          borderRadius: 8,
                          boxShadow:
                            "0 8px 24px rgba(0,0,0,.15)",
                          zIndex: 9999,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={menuItem}
                          onClick={(event) => {
                            event.stopPropagation();
                            setShowBulkMenu(false);
                            setShowAssignModal(true);
                          }}
                        >
                          Assign selected
                        </div>

                        <div
                          style={menuItem}
                          onClick={(event) => {
                            event.stopPropagation();
                            setShowBulkMenu(false);
                            restoreSelected();
                          }}
                        >
                          Mark as active
                        </div>

                        <div style={menuItem}>
                          Send SMS
                        </div>

                        <div style={menuItem}>
                          Send Whatsapp
                        </div>

                        <div style={menuItem}>
                          Send Email
                        </div>

                        <div
                          style={{
                            ...menuItem,
                            color: "#DC2626",
                            borderBottom: "none",
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            handleDeleteSelected();
                          }}
                        >
                          Delete selected
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          {leads.length === 0 ? (
            <tr>
              <td
                colSpan="14"
                className="empty"
              >
                No Leads Found
              </td>
            </tr>
          ) : (
            leads.map((lead, index) => {
              const isSelected =
                selectedLeads.includes(lead.id);
                const isDuplicate =
  lead.is_duplicate === true ||
  lead.duplicate === true ||
  Number(lead.duplicate_count || 0) > 1;

              return (
                <tr
                  key={lead.id}
                  className="deal-row"
                  onClick={() =>
                    toggleLead(lead.id)
                  }
                  style={{
  background: isSelected
    ? "#ECFDF5"
    : isDuplicate
    ? "#FEF2F2"
    : undefined,

  cursor: "pointer",
}}
                >
                  <td>
                    {(page - 1) * limit +
                      index +
                      1}
                  </td>

                  <td>
                    {lead.created_at
                      ? new Date(
                          lead.created_at
                        ).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>

                  <td
  onClick={(event) => {
    event.stopPropagation();
    window.open(`/drop/${lead.id}`, "_blank");
  }}
>
                    <strong
                      style={{
                        fontSize: 14,
                        color: "#222",
                        fontWeight: 700,
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(event) => {
                        event.currentTarget.style.textDecoration =
                          "underline";
                      }}
                      onMouseLeave={(event) => {
                        event.currentTarget.style.textDecoration =
                          "none";
                      }}
                    >
                      {lead.name ||
                        "Unnamed Lead"}
                    </strong>
                  </td>

                  <td
                    style={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    {lead.phone || "-"}
                  </td>

                  <td>
                    <span
                      style={{
                        padding: "4px 10px",
                        background: "#F3F4F6",
                        borderRadius: 20,
                        fontSize: 12,
                        color: "#555",
                        display: "inline-block",
                      }}
                    >
                      {(lead.source || "Unknown")
                        .split("(")[0]
                        .trim()}
                    </span>
                  </td>

                  <td>
                    {lead.campaign_name || "-"}
                  </td>

                  <td>
                    <span
                      style={{
                        background: `${stageColor(
                          lead.stage
                        )}20`,
                        color: stageColor(
                          lead.stage
                        ),
                        padding: "5px 12px",
                        borderRadius: 20,
                        fontSize: 12,
                        fontWeight: 600,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: stageColor(
                            lead.stage
                          ),
                          display: "inline-block",
                        }}
                      />

                      {lead.stage || "-"}
                    </span>
                  </td>

                  <td>
                    {lead.drop_reason || "-"}
                  </td>

                  <td>
  {lead.dropped_by_name || "-"}
</td>

<td>
  {lead.dropped_at
    ? new Date(
        lead.dropped_at
      ).toLocaleDateString(
        "en-IN"
      )
    : "-"}
</td>

<td>
  {lead.response_time_seconds != null
    ? `${Math.floor(
        lead.response_time_seconds / 3600
      )} hours ${Math.floor(
        (lead.response_time_seconds % 3600) / 60
      )} min`
    : "-"}
</td>

<td>
  {lead.follow_up_count ?? 0}
</td>

<td>
  {lead.assigned_to_name || "-"}
</td>

<td
  onClick={(event) =>
    event.stopPropagation()
  }
>
  <input
    type="checkbox"
    checked={isSelected}
    onChange={() =>
      toggleLead(lead.id)
    }
  />
</td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}